import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://solplanet.tecnologiacharra.com';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        email,
        password,
      });
      login(response.data.access_token);
      navigate('/');
    } catch (err) {
      setError('Credenciales inválidas. Por favor intenta de nuevo.');
    }
  };

  return (
    <div className="min-h-screen flex w-full">
      <div className="flex-1 flex flex-col justify-center items-center px-6 md:px-12 py-8 bg-background">
        <div className="w-full max-w-md bg-card p-6 sm:p-8 rounded-xl border border-border shadow-sm transform transition-all duration-200">
          <div className="mb-8 text-center">
            <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-foreground mb-2">Sol Planet</h1>
            <p className="text-muted-foreground font-sans text-sm">Bienvenido a Sol Planet. Iniciar sesión.</p>
          </div>
          
          {error && (
            <div className="bg-destructive/10 border border-destructive/20 text-destructive px-4 py-3 rounded mb-4 text-sm font-sans">
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-6 font-sans">
            <div>
              <label className="block text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-2">Correo Electrónico</label>
              <input 
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-input bg-background focus:outline-none focus:ring-2 focus:ring-primary/30 transition-shadow"
                placeholder="admin@solplanet.com"
                required
              />
            </div>
            
            <div>
              <label className="block text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground mb-2">Contraseña</label>
              <input 
                type="password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-input bg-background focus:outline-none focus:ring-2 focus:ring-primary/30 transition-shadow"
                placeholder="••••••••"
                required
              />
            </div>

            <button 
              type="submit"
              data-testid="btn-login"
              className="w-full bg-primary hover:bg-[#C05A3B] text-primary-foreground font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
            >
              Iniciar Sesión
            </button>
          </form>
        </div>
      </div>
      <div className="hidden lg:block lg:flex-1 bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1690068867787-333bb850f36e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHx3YXJtJTIwdGVycmFjb3R0YSUyMGFic3RyYWN0JTIwc3Vuc2V0JTIwd2F2ZXMlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NTg5OTkzNHww&ixlib=rb-4.1.0&q=85')" }}>
        <div className="w-full h-full bg-black/10"></div>
      </div>
    </div>
  );
};

export default Login;
